
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { validationMixin } from "vuelidate";
import {
  SistemaMixin,
  ValidacaoMixin,
  PessoaMixin,
} from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeServicos";
import { ClienteDataRequired } from "../ClienteData";
import NovoClienteModal from "@/modules/Pessoa/components/NovoClienteModal.vue";

export default {
  name: "app-nfse-form-tomador",
  components: {
    VueSelect,
    NovoClienteModal,
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      emissao: null,
      firstLoad: false,
      clientSelected: {
        cnpj_cpf: null,
      },
      clients: [],
      clienteFilled: false,
      clienteError: false,
      enderecoError: false,
      enderecoFilled: false,
      keyToReRender: 0,
      enderecos: [],
      realizar_reducao: false,
      calcular_substituicao: false,
      cidades_prestadas: [],
      cidade_prestada: null,
      tipoBairro: [
        {
          descricao: "Bairro",
        },
        {
          descricao: "Chácara",
        },
        {
          descricao: "Distrito",
        },
        {
          descricao: "Fazenda",
        },
        {
          descricao: "Vila",
        },
      ],
      tipoLogradouro: [
        {
          descricao: "Rua",
        },
        {
          descricao: "Avenida",
        },
        {
          descricao: "Estrada",
        },
        {
          descricao: "Condomínio",
        },
        {
          descricao: "Sítio",
        },
        {
          descricao: "Travessa",
        },
        {
          descricao: "Rodovia",
        },
      ],
    };
  },
  validations: {
    form: ClienteDataRequired,
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, PessoaMixin],
  methods: {
    ...mapActions(["setLoading"]),
    onSearchEmail() {},
    onSearchCliente(search, loading) {
      if (search.length > 2) {
        loading(true);
        this.searchCliente(loading, search, this);
      }
    },
    searchCliente: _.debounce(async (loading, search, vm) => {
      vm.clients = await vm.getClientes(search);
      loading(false);
    }, 350),
    setCliente(cliente) {
      if (!cliente) return;
      if (this.bloquearClienteInadimplenteSelecionado(cliente)) {
        this.store.formTomador = {};
        this.clienteFilled = false;
        this.enderecos = [];
        this.keyToReRender++;
        return;
      }

      const enderecos = cliente.enderecos ?? cliente.endereco ?? [];

      this.store.formTomador = {
        ...cliente,
        enderecos,
      };
      this.clienteFilled = true;
      this.enderecos = enderecos;
      this.store.formTomador.endereco = enderecos[0] ?? null;
      this.keyToReRender++;
    },
    handleNovoClienteSelected(cliente) {
      this.setCliente(cliente);
    },
    async getTomador(id_pessoa) {
      const pessoa = await this.getPessoa(id_pessoa);
      this.store.formTomador = {
        ...this.store.formTomador,
        ...pessoa,
      };
    },
    searchEndereco: _.debounce(async (loading, search, vm) => {
      vm.enderecos = vm.enderecos.filter((endereco) =>
        endereco.includes(search)
      );
      loading(false);
    }, 350),
    onSearchEndereco(search, loading) {
      if (search.length) {
        loading(true);
        this.searcEndereco(loading, search, this);
      }
    },
    setEndereco(endereco) {
      this.store.formTomador.endereco = endereco;
      this.keyToReRender++;
      this.enderecoFilled = true;
    },
    formatEndereco(endereco) {
      if (!endereco) return "";
      const formatData = `${endereco.cep ?? ""}, ${
        endereco.logradouro ?? ""
      }, ${endereco.numero ?? ""}, ${endereco.bairro ?? ""} - ${
        endereco?.cidade?.cidade ?? ""
      } / ${endereco?.cidade?.uf ?? ""}`;
      return formatData;
    },
    async consultaCepCidadePretado() {
      this.setLoading(true);
      const cep = await this.getCep(this.store.formTomador.cep_prestado);

      if (cep.length == 0) {
        this.setLoading(false);
        return;
      }

      this.store.formTomador.logradouro_prestado = cep.logradouro;
      this.store.formTomador.bairro_prestado = cep.bairro;
      this.store.formTomador.complemento_prestado = cep.complemento;

      if (cep.erro) {
        this.setLoading(false);
        this.$toast.warning("Confira o CEP informado!");
        return;
      }

      const city = await this.getCidadeByUF(cep.localidade, cep.uf);
      this.cidades_prestadas = city;
      this.setLoading(false);
    },
    setCidadePrestada(cidade) {
      this.store.formTomador.cidade_prestada = cidade;
    },
    onSearch(search, loading) {
      if (search.length) {
        loading(true);
        this.search(loading, search, this);
      }
    },
    search: _.debounce(async (loading, search, vm) => {
      const city = await vm.getCidade(search);
      vm.cidades_prestadas = city;
      loading(false);
    }, 350),
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      const { tomador, data_emissao, endereco } = this.$route.params.nfseData;
      this.getTomador(tomador.id_pessoa);
      this.emissao = data_emissao;
      this.store.formTomador.endereco = endereco;
    } else {
      this.store.formTomador = {};
      this.emissao = this.thisDate();
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 0;
    },
    valueAdress() {
      return this.store.formTomador?.endereco
        ? this.formatEndereco(this.store.formTomador.endereco)
        : null;
    },
  },
  watch: {
    "store.currentTab"(newValue, oldValue) {
      if (newValue !== oldValue && newValue === 1 && oldValue < newValue) {
        if (_.isEmpty(this.store.formTomador)) {
          this.$toast.error("Selecione o tomador!");
          this.store.currentTab = oldValue;
          return;
        }
        if (_.isEmpty(this.store.formTomador.endereco)) {
          this.$toast.error("Selecione um endereço!");
          this.store.currentTab = oldValue;
        }
        if (!this.emissao) {
          this.store.currentTab = oldValue;
          this.$toast.error("Informe a data de emissão!");
        }
        this.store.formTomador.emissao = this.emissao;
      }
    },
  },
};
